import { Controller } from "stimulus";
import { EventCurrencyChanged, EventShowFDV, EventTickersMoreLoaded } from "../events";
import { EventPriceLoaded } from "../events";
import { reloadBootstrapTooltip } from "../util/tooltip";
import { sortWithTableSort } from "../util";
import Cookies from "js-cookie";

export default class extends Controller {
  static targets = [
    "moreFilters",
    "tableContainer",
    "table",
    "tab",
    "paginate",
    "paginatedShowMoreTbody",
    "showMore",
    "loading",
    "tableSearchFilter",
    "line",
    "showFdvSwitch",
    "showFdvSwitchAnimation",

    // New customise button
    "d30Toggle", "fdvToggle", "ratioToggle", "customiseButton"
  ];

  connect() {
    if (this.hasPaginatedShowMoreTbodyTarget) {
      this.page = 0;
      this.perPage = 100;
      this.rowCount = this.paginatedShowMoreTbodyTarget.children.length;
      // Hide button if first page not full
      var hasMoreToLoad = this.rowCount == this.perPage;
      this._showButton(hasMoreToLoad);
    }

    this.queryString = window.location.search;

    this._setupTableSorting()
    if (this.hasCustomiseButtonTarget) {
      this.d30Enabled = localStorage.getItem("categoryShow:d30") == "true";
      this.fdvEnabled = localStorage.getItem("categoryShow:fdv") == "true";
      this.ratioEnabled = localStorage.getItem("categoryShow:ratio") == "true";

      this._refresh();
    } else {
      if (this._showFdvEnable()) {
        this._showFdvStats();
      } else {
        this._hideFdvStats();
      }

      window.addEventListener(EventShowFDV, e => {
        this.showFdvWithoutToggle(e);
      });
    }
  }

  toggleMoreFilters(e) {
    e.target.classList.toggle("tw-border-primary-500");
    this.lineTarget.classList.toggle("tw-hidden");
    this.moreFiltersTarget.classList.toggle("tw-hidden");
  }

  executeFilter(event) {
    var hashing_algorithm = event.target.getAttribute("data-hashing-algorithm");
    var asset_platform_id = event.target.getAttribute("data-asset-platform-id");
    var category_id = event.target.getAttribute("data-category-id");

    var searchParams = new URLSearchParams("");
    if (hashing_algorithm != null) {
      searchParams.append("hashing_algorithm", hashing_algorithm);
    } else {
      searchParams.delete("hashing_algorithm");
    }
    if (asset_platform_id != null) {
      searchParams.append("asset_platform_id", asset_platform_id);
    } else {
      searchParams.delete("asset_platform_id");
    }
    if (category_id != null) {
      searchParams.append("category_id", category_id);
    } else {
      searchParams.delete("category_id");
    }
    window.location.search = searchParams.toString();
  }

  /* Helper Methods */

  filterTable(e) {
    var value = this.tableSearchFilterTarget.value.toLowerCase();
    var tables = this.tableTargets;
    var trs = [];
    tables.forEach(function(table) {
      for (let tr of table.getElementsByTagName("tbody")[0].getElementsByTagName("tr")) {
        trs.push(tr);
      }
    });
    $(trs).filter(function() {
      $(this).toggle(
        $(this)
          .text()
          .toLowerCase()
          .indexOf(value) > -1
      );
    });

    // Meant to target Derivatives ticker filtering to hide section
    tables.forEach(function(table) {
      var table_trs = $(table.getElementsByTagName("tbody")[0].getElementsByTagName("tr"));

      if (
        table_trs.filter(function() {
          return $(this).css("display") == "none";
        }).length == table_trs.length
      ) {
        $(table)
          .parents(".contract-table")
          .hide();
      } else {
        $(table)
          .parents(".contract-table")
          .show();
      }
    });
  }

  showMore(e) {
    this._showButton(false);
    this._showSpinner(true);
    this.page += 1;

    fetch(`${this.showMoreTarget.dataset.url}?page=${this.page}&per_page=${this.perPage}`, {
      credentials: "same-origin"
    })
      .then(response => response.text())
      .then(res => {
        if (res) {
          this.paginatedShowMoreTbodyTarget.insertAdjacentHTML("beforeend", res);

          this._showButton(true);
          this._showSpinner(false);
          reloadBootstrapTooltip();

          const newRowCount = this.paginatedShowMoreTbodyTarget.children.length;
          if (this.perPage > newRowCount - this.rowCount) {
            // Nothing more to load.
            this._showButton(false);
            this._showSpinner(false);
          }
          this.rowCount = newRowCount;
          // Incoming rows are in USD, we need to convert to target currency. Run price formatter.
          this.element.dispatchEvent(
            new CustomEvent(EventPriceLoaded, {
              bubbles: true
            })
          );
          this.element.dispatchEvent(
            new CustomEvent(EventTickersMoreLoaded, {
              bubbles: true
            })
          );
        } else {
          this._showButton(false);
          this._showSpinner(false);
        }
      });

    // Prevent hash from showing in URL
    e.preventDefault();
  }

  _showButton(show) {
    if (!this.hasShowMoreTarget) {
      return;
    }

    this.showMoreTarget.style.display = show ? "" : "none";
  }

  _showSpinner(show) {
    this.loadingTarget.style.display = show ? "" : "none";
  }

  showFdv(e){
    e.preventDefault();
    if (this._showFdvEnable()) {
      this._hideFdvStats(e);
    } else {
      this._showFdvStats(e);
    }
  }

  showFdvWithoutToggle(e) {
    e.preventDefault();
    if (this._showFdvEnable()) {
      this._showFdvStats(e);
    } else {
      this._hideFdvStats(e);
    }
  }

  _showFdvEnable() {
    return Cookies.get("geckoTableFdvStats") === "true";
  }

  _showFdvStats() {
    Cookies.set("geckoTableFdvStats", true, { path: "/" });
    this.showFdvSwitchTargets.forEach((element) => {
      element.classList.remove("tw-bg-gray-200");
      element.classList.add("tw-bg-primary-600");
    });
    this.showFdvSwitchAnimationTargets.forEach((element) => {
      element.classList.remove("tw-translate-x-0");
      element.classList.add("md:tw-translate-x-4");
      element.classList.add("tw-translate-x-5");
    });
    document.querySelectorAll(".fdv").forEach((element) => {
      element.classList.remove("tw-hidden");
      element.classList.add("tw-block-inline");
    })
  }

  _hideFdvStats() {
    Cookies.set("geckoTableFdvStats", false, { path: "/" });
    this.showFdvSwitchTargets.forEach((element) => {
      element.classList.remove("tw-bg-primary-600");
      element.classList.add("tw-bg-gray-200");
    });
    this.showFdvSwitchAnimationTargets.forEach((element) => {
      element.classList.remove("md:tw-translate-x-4");
      element.classList.add("tw-translate-x-0");
      element.classList.remove("tw-translate-x-5");
    });
    document.querySelectorAll(".fdv").forEach((element) => {
      element.classList.add("tw-hidden");
      element.classList.remove("tw-block-inline");
    })
  }

  _setupTableSorting() {
    if (!this.hasTableTarget) {
      return;
    }

    // portfolio table has data populated through API, sorting needs to be done later.
    if (this.data.get("page") !== "portfolio") {
      sortWithTableSort(this.tableTargets)
    }
  }

  /* FORWARDS COMPAT: For Categories page. Shouldn't be used anywhere else. */
  // TODO: Remove upon migrating to V2. This should be within the page JS logic in its own controller.
  handle30d() {
    this.d30Enabled = !this.d30Enabled;
    localStorage.setItem("categoryShow:d30", this.d30Enabled);

    this._refresh();
  }

  handleFdv() {
    this.fdvEnabled = !this.fdvEnabled;
    localStorage.setItem("categoryShow:fdv", this.fdvEnabled);

    this._refresh();
  }

  handleRatio() {
    this.ratioEnabled = !this.ratioEnabled;
    localStorage.setItem("categoryShow:ratio", this.ratioEnabled);

    this._refresh();
  }

  _refresh() {
    this.d30ToggleTarget.checked = this.d30Enabled;
    this.fdvToggleTarget.checked = this.fdvEnabled;
    this.ratioToggleTarget.checked = this.ratioEnabled;

    this.tableTarget.querySelectorAll(".change30d.d30").forEach(x => x.classList.toggle("tw-hidden", !this.d30Enabled));
    this.tableTarget.querySelectorAll(".fdv.fdv-amt").forEach(x => x.classList.toggle("tw-hidden", !this.fdvEnabled));
    this.tableTarget.querySelectorAll(".fdv.ratio").forEach(x => x.classList.toggle("tw-hidden", !this.ratioEnabled));
  }
}
